package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminNote(
    val id: String,
    @SerialName("target_type") val targetType: AdminTargetType,
    @SerialName("target_id") val targetId: String,
    @SerialName("author_id") val authorId: String?,
    @SerialName("author_name") val authorName: String?,
    val body: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("updated_at") val updatedAt: String?,
)
